<div class="info-modal-root">

  <!-- ═══════════════ HEADER ═══════════════ -->
  <div class="info-header">
    <div class="header-backdrop"></div>
    <div class="header-content">
      <button class="back-btn" (click)="cerrar()">
        <ion-icon name="chevron-back-outline"></ion-icon>
      </button>
      <div class="header-text">
        <span class="header-label">{{ subtitle }}</span>
        <h1 class="header-title">{{ title }}</h1>
      </div>
    </div>
    <div class="header-wave">
      <svg viewBox="0 0 1200 60" preserveAspectRatio="none">
        <path d="M0,30 C300,60 900,0 1200,30 L1200,60 L0,60 Z" fill="var(--body-bg)"/>
      </svg>
    </div>
  </div>

  <!-- ═══════════════ CONTENT ═══════════════ -->
  <ion-content class="info-content">
    <div class="sections-wrap">
      
      <div class="info-section" style="animation-delay: 50ms;">
        <!-- Form card -->
        <div class="section-card form-container">
          <div class="field-item" *ngFor="let field of fields; let idx = index" [style.animation-delay]="(idx * 60) + 'ms'">
            <label class="field-label">{{ field.label }}</label>
            
            <div class="input-wrap" [ngSwitch]="field.type">
              <ion-icon class="input-icon" [name]="getIcon(field.key)"></ion-icon>
              
              <!-- Text input -->
              <input *ngSwitchCase="'text'" 
                     type="text" 
                     class="custom-input with-icon" 
                     [placeholder]="field.placeholder || ''" 
                     [(ngModel)]="field.value">

              <!-- Date input -->
              <input *ngSwitchCase="'date'" 
                     type="date" 
                     class="custom-input with-icon" 
                     [(ngModel)]="field.value">

              <!-- Number input -->
              <input *ngSwitchCase="'number'" 
                     type="number" 
                     class="custom-input with-icon" 
                     [placeholder]="field.placeholder || ''" 
                     [(ngModel)]="field.value">

              <!-- Textarea input -->
              <textarea *ngSwitchCase="'textarea'" 
                        class="custom-textarea with-icon" 
                        [placeholder]="field.placeholder || ''" 
                        [(ngModel)]="field.value" 
                        rows="4"></textarea>
            </div>
          </div>
        </div>

        <!-- Contenedor premium de la imagen de la factura debajo del formulario -->
        <div class="factura-image-preview-card" *ngIf="filename && !filename.toLowerCase().endsWith('.pdf')">
          <div class="card-header-simple">
            <ion-icon name="image-outline"></ion-icon>
            <span>Documento Adjunto (Factura)</span>
          </div>
          
          <div class="image-load-zone">
            <!-- Spinner / Estado cargando -->
            <div class="image-spinner-wrapper" *ngIf="loadingImage">
              <ion-spinner name="crescent" color="primary"></ion-spinner>
              <p>Cargando vista previa del documento...</p>
            </div>
            
            <!-- Imagen cargada -->
            <img [src]="imageUrl" *ngIf="!loadingImage && imageUrl" (click)="ver()">
            
            <!-- Error de carga -->
            <div class="image-error-wrapper" *ngIf="!loadingImage && !imageUrl">
              <ion-icon name="alert-circle-outline" color="medium"></ion-icon>
              <p>No se pudo cargar la vista previa</p>
            </div>
          </div>
        </div>

        <!-- Botón de extracción con IA (Posicionado debajo de la imagen) -->
        <div class="ai-fill-bar" *ngIf="filename && !filename.toLowerCase().endsWith('.pdf')" (click)="llenarConIA()" [class.disabled]="loadingAI" style="margin-top: 14px;">
          <ion-spinner name="crescent" *ngIf="loadingAI"></ion-spinner>
          <ion-icon name="sparkles-outline" *ngIf="!loadingAI"></ion-icon>
          <span>{{ aiAttemptStatus }}</span>
        </div>

      </div>

    </div>
  </ion-content>

  <!-- Botones de acción en el footer copiados de la estructura de trabajosEdit -->
  <div class="form-footer-actions">
    <ion-button (click)="cerrar()" fill="outline" class="cancel-modal-btn">
      <ion-icon name="close-outline" slot="start"></ion-icon>
      Cancelar
    </ion-button>

    <ion-button (click)="guardar()" class="save-btn">
      Guardar Cambios
      <ion-icon name="checkmark-done-outline" slot="end"></ion-icon>
    </ion-button>
  </div>
</div>
